var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.block.hidden && _vm.blockReady)?_c('div',{staticClass:"preview-block-editor",class:{
    'opacity-0': _vm.isPresentingDefaultContent
  },attrs:{"id":_vm.containerId}},[_c('BlockEditor',{attrs:{"component-data":_vm.componentData,"type":_vm.block.type,"preview":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }